function unaVez<T extends Event = Event>(elemento: HTMLElement, evento: string, accion: (e: T) => boolean | void) {
    const funcion = (e: Event) => {
        if (accion(e as T) !== false) {
            elemento.removeEventListener(evento, funcion);
        }
    };

    elemento.addEventListener(evento, funcion);
}

export {unaVez};